import parse from "postcss/lib/parse";
import ApplicationController from "./application_controller";
import { FetchRequest } from "@rails/request.js";
import Sortable from 'sortablejs';

export default class extends ApplicationController {
  static targets = ["carouselitem", "carousel"];

  connect() {
    if(this.carouselTarget) {
      var sortable = Sortable.create(this.carouselTarget, {
        animation: 150
      });
    }
  }

  async deleteImage(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!window.confirm("Soll diese Bild wirklich entfernt werden?")) {
      return false;
    }
    console.log("now delete! " + e.target.dataset.imageid);

    const request = new FetchRequest("post", "/ads/deleteimage", {
      body: JSON.stringify({
        ad: {
          adid: this.element.dataset.adid,
          imageid: e.target.dataset.imageid,
        },
        contentType: "application/json",
        headers: {
          "Accept": "application/json"
        }
      }),
    });
    const response = await request.perform();
    if (response.ok) {
      console.log("did respond ok " + response.text);
      e.target.closest(".carousel-item").remove();
    }
  }

  async moveImageLeft(e) {
    e.stopPropagation();
    e.preventDefault();
    let carouselItem = e.target.closest('.carousel-item');
    let currentPosition = parseInt(carouselItem.dataset.adformPosition) - 1;

    var newposition = currentPosition - 1;

    if(newposition <= 0 ) {
      newposition = this.carouselitemTargets.length - 1;
    }
    console.log(`current poisition: ${currentPosition}`)
    this.moveItem(carouselItem, newposition);
    carouselItem.dataset.adformPoisition = newposition + 1;
  }

    moveImageRight(e) {
      e.stopPropagation();
      e.preventDefault();
      console.log(JSON.stringify(e.target.dataset));
      let carouselItem = e.target.closest('.carousel-item');
      let currentPosition = parseInt(carouselItem.dataset.adformPosition) - 1;

      var newposition = currentPosition + 1;
      if(newposition >= (this.carouselitemTargets.length) ) {
        newposition = 0;
      }
      console.log(`current poisition: ${currentPosition}`)
      this.moveItem(carouselItem, newposition);
      carouselItem.dataset.adformPosition = newposition + 1 ;
  }


  moveItem(carouselItem, newposition) {
    console.log(JSON.stringify(this.carouselitemTargets));
    // Get all carousel item targets as an array
    const carouselItemsArray = Array.from(this.carouselitemTargets);

    // Get the reference element to insert before
    const referenceElement = carouselItemsArray[newposition];

    // Insert the item at the new position
    this.carouselTarget.insertBefore(carouselItem, referenceElement);
    console.log(JSON.stringify(this.carouselitemTargets));
  }

  submitImages(e) {
    e.stopPropagation();
    e.preventDefault();
    this.element.querySelectorAll('.carousel-item').forEach((item, index) => {
      console.log(item);
      let hinput = document.createElement('input');
      hinput.type = 'hidden';
      hinput.name = `image_positions[${item.dataset.adimageid}]`;
      hinput.value = JSON.stringify({blobid: item.dataset.blobid, position: index});
      this.element.appendChild(hinput);
    });
    this.element.submit();
  }
}
